module.exports = __webpack_public_path__ + "141d4a85/img/verified-icon.f93bbc14.svg";